import biomedicalImagingLinks from './biomedicalImagingLinks';

export default biomedicalImagingLinks;
